// extracted by mini-css-extract-plugin
export default {"wrapper":"Hu","order_date":"Iu","loading":"Ju","banner":"Ku","title":"Lu","subtitle":"Mu","fsa":"Nu"};
    if(module.hot) {
      // 1743628922721
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  